import { render } from "./BaseTopAppBar.vue?vue&type=template&id=2460bf4f"
import script from "./BaseTopAppBar.vue?vue&type=script&lang=js"
export * from "./BaseTopAppBar.vue?vue&type=script&lang=js"

import "./BaseTopAppBar.vue?vue&type=style&index=0&id=2460bf4f&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__